/**
 * Animate on Scroll with Intersection Observer - JavaScript
 * If this solution becomes not enough at some point we can use
 * this light weight library based on Intersection Observer https://github.com/mciastek/sal
 */

const selector = '.fade, .slide-up, .zoom-in, .two-parts';
const animateClassName = 'animate';
const options = {
    root: null, // use the document's viewport as the container
    rootMargin: '10px', // % or px - offsets added to each side of the intersection, it delays the intersection event by set distance
    threshold: 0, // percentage of the target element which is visible
};

// Callback docs: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Targeting_an_element_to_be_observed
const callback = (entries) => {
    entries.forEach((element) => {
        // If selector entry is visible - according with the params set in `options`
        if (element.isIntersecting) {
            // add a class to an element that enters the viewport to animate it
            element.target.classList.add(animateClassName);

            // stop observing already animated elements to save memory
            observer.unobserve(element.target);
        }
    });
};

// Create the intersection observer instance by calling its constructor and passing it a
// callback function to be run whenever a threshold is crossed in one direction or the other:
const observer = new IntersectionObserver(callback, options);

// When document is ready, get all selectors from DOM and attach the observer to these
document.querySelectorAll(selector).forEach((element) => {
    observer.observe(element);
});

// allow the following objects, functions and variables to be imported into other JavaScript files
export { selector, observer };

// NOTE: example of animating
// import { selector, observer } from '../other/animations.js';
// // limit observer only to elements in newly added container
// // this way you can save memory, by avoiding adding multiple observers to same elements
// const nodeContainer = document.querySelectorAll('.loaded-container');
// nodeContainer.querySelectorAll(selector).forEach((element) => {
//     observer.observe(element);
// });



// WEBPACK FOOTER //
// resources/assets/scripts/routes/other/animations.js